import React from 'react';
import './LoaderBigTwo.css'

const LoaderBigTwo = () => {
    return (
        <div className='flex justify-center items-center h-screen w-full'>
            <span class="loader"></span>
        </div>
    );
};

export default LoaderBigTwo;